
import React, { memo } from 'react';

interface StableTabContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  height?: string | number;
}

export const StableTabContainer = memo(function StableTabContainer({
  children,
  className,
  style,
  height = '800px'
}: StableTabContainerProps) {
  const containerStyle: React.CSSProperties = {
    position: 'relative',
    overflowY: 'auto', // Changed from 'visible' to 'auto' to enable scrolling
    minHeight: height, // Keep minHeight for flexibility
    height: 'auto',    // Allow content to determine height
    width: '100%',
    maxWidth: '100%',
    contain: 'layout style paint',
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateZ(0)', // Promote to a layer to prevent layout shifts
    willChange: 'opacity',
    backfaceVisibility: 'hidden',
    ...style
  };
  
  return (
    <div 
      className={`stable-tab-container ${className || ''}`}
      style={containerStyle}
    >
      {children}
    </div>
  );
});
